var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricboardFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5006_9503",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66428 5.89976C8.79129 5.89976 8.8576 5.89996 8.90664 5.90216C8.9212 5.90281 8.93036 5.90351 8.93539 5.90398C8.94129 5.90575 8.94701 5.90806 8.95248 5.91088C8.95642 5.91404 8.9635 5.9199 8.97443 5.92954C9.01124 5.96202 9.05908 6.00793 9.15046 6.09614L10.2922 7.19838L10.3274 7.23243C10.4619 7.36283 10.621 7.51715 10.8135 7.63189C10.9809 7.73166 11.1627 7.80508 11.3525 7.84957C11.5707 7.90074 11.7923 7.90024 11.9796 7.89982L20.0999 7.89975L20.1 18.0997H3.89998L3.90001 5.89976H8.66428ZM9.34042 4.14994C9.12221 4.09877 8.90054 4.09927 8.71322 4.09969L3.77791 4.09976C3.65767 4.09972 3.51936 4.09967 3.39832 4.10956C3.25929 4.12092 3.06593 4.14968 2.86443 4.25235C2.601 4.38657 2.38683 4.60074 2.25261 4.86417C2.14994 5.06567 2.12118 5.25903 2.10982 5.39807C2.09993 5.5191 2.09997 5.65741 2.10001 5.77765L2.09998 18.2218C2.09994 18.3421 2.0999 18.4804 2.10979 18.6014C2.12114 18.7404 2.14991 18.9338 2.25257 19.1353C2.3868 19.3987 2.60097 19.6129 2.86439 19.7471C3.06589 19.8498 3.25926 19.8786 3.39829 19.8899C3.51933 19.8998 3.65764 19.8998 3.77788 19.8997H20.2221C20.3423 19.8998 20.4806 19.8998 20.6017 19.8899C20.7407 19.8786 20.9341 19.8498 21.1356 19.7471C21.399 19.6129 21.6132 19.3987 21.7474 19.1353C21.85 18.9338 21.8788 18.7404 21.8902 18.6014C21.9011 18.4679 21.9 18.3336 21.9 18.1997L21.8999 7.77769C21.8999 7.65746 21.9 7.51909 21.8901 7.39806C21.8787 7.25902 21.85 7.06566 21.7473 6.86416C21.6131 6.60074 21.3989 6.38657 21.1355 6.25234C20.934 6.14968 20.7406 6.12092 20.6016 6.10956C20.4806 6.09967 20.3422 6.09971 20.222 6.09975L12.0286 6.09976C11.9016 6.09976 11.8353 6.09955 11.7862 6.09735C11.7717 6.0967 11.7625 6.096 11.7575 6.09553C11.7516 6.09376 11.7459 6.09145 11.7404 6.08863C11.7365 6.08547 11.7294 6.07961 11.7184 6.06998C11.6816 6.03749 11.6338 5.99159 11.5424 5.90337L10.3655 4.76708C10.231 4.63668 10.0719 4.48237 9.87933 4.36763C9.71192 4.26785 9.53016 4.19443 9.34042 4.14994Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5006_9503)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9999,
    height: 23.9999,
    fill: "#171719"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricboardFile);
export default __webpack_public_path__ + "static/media/electricboard-file.b3ee07add518c03355fb993b1bd658d0.svg";
export { ForwardRef as ReactComponent };